import React from 'react';
import { MessageCircleIcon, PhoneIcon, SendIcon } from 'lucide-react';
const phone = '+380971234567';
type ContactSectionProps = {
  heading?: string;
};
export function ContactSection({
  heading = 'Зв’яжіться напряму'
}: ContactSectionProps) {
  return <section aria-label="Контакти" className="space-y-2.5" data-id="element-20" data-mp="2khkl1799euvw">
      <h2 className="px-1 text-[14px] font-bold text-slate-900" data-id="element-21" data-mp="2pjs1a914gx41">{heading}</h2>
      <a href={`tel:${phone}`} className="contact-row border-slate-200 text-slate-900 hover:border-slate-300" data-id="element-22" data-mp="3d7t73a6x1zfr">
        <span className="contact-icon bg-slate-900 text-white" data-id="element-23" data-mp="3i6vyvsxvy95s">
          <PhoneIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-24" data-mp="34863chqpshjj" />
        </span>
        <span className="flex-1 font-bold" data-id="element-25" data-mp="388ydrebboshe">+38 (097) 123-45-67</span>
      </a>
      <a href="viber://chat?number=%2B380971234567" className="contact-row border-[#7360F2]/25 text-slate-900 hover:border-[#7360F2]/50" data-id="element-26" data-mp="38b2pujjdkxsr">
        <span className="contact-icon bg-[#7360F2] text-white" data-id="element-27" data-mp="1wuuj05wwv0ba">
          <MessageCircleIcon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-28" data-mp="7lmtmbcz2lar" />
        </span>
        <span className="flex-1 font-bold" data-id="element-29" data-mp="2nbky3yeygu4">Написати у Viber</span>
      </a>
      <a href="https://t.me/+380971234567" className="contact-row border-[#0088cc]/25 text-slate-900 hover:border-[#0088cc]/50" data-id="element-30" data-mp="2pejjcdmtiag">
        <span className="contact-icon bg-[#0088cc] text-white" data-id="element-31" data-mp="ck6fycvh9z3n">
          <SendIcon className="h-[17px] w-[17px]" aria-hidden="true" data-id="element-32" data-mp="qkr13fov870b" />
        </span>
        <span className="flex-1 font-bold" data-id="element-33" data-mp="qio4udx4dhn5">Написати у Telegram</span>
      </a>
    </section>;
}